import ConcluirPage from './concluir.page'

export default ConcluirPage
